export const API_URL = 'https://feathers.287arthub.com/';
export const ADMIN_ID = '5fb3b2dcad060c0a845047f3';
export const DEFAULT_EMAIL = "defaultUser@gmail.com";
export const DEFAULT_PSW = ")j~nKj/,N}N6,8&cVVV#G!=F*y";
export const PHONE_REGEX =/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/ ;
export const PAYPAL_CLIENT_ID="Ab9xBziZRnJjCwgOIgQb-uTWsr6cWG1B5nCVup5m2EcrZib1dD7V70LViTk6rL3ZvPH0Sg3IAFQDBLFZ"